import React, { useEffect, useState } from 'react';
import { Form, message } from 'antd';
import { useHistory } from 'react-router-dom';

import { login, register } from 'api/users';
import { setToken, setRefreshToken } from 'helpers/token';
import urls from 'constants/urls';
import { useUserContext } from 'contexts/UserProvider';
import { LoginForm, SignupForm, ForgotPasswordForm } from './components';
import Slider from './components/Slider';

import s from './styles.module.scss';

interface LoginFormData {
  login: string;
  password: string;
}

interface SignupFormData {
  email: string;
  first_name: string;
  last_name: string;
  company_name: string;
  password: string;
  agree: boolean;
}

export default function Login() {
  const [form] = Form.useForm();
  const [signupForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [signupLoading, setSignupLoading] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const history = useHistory();
  const { logIn } = useUserContext();

  const onFinish = async (values: LoginFormData) => {
    setLoading(true);
    try {
      const response = await login(values);

      // Store the token
      setToken(response.access_token);
      setRefreshToken(response.refresh_token);

      // Use UserProvider's logIn
      await logIn(() => {
        // message.success('Login successful!');
        const intendedPath = sessionStorage.getItem('intendedPath');
        if (intendedPath && intendedPath !== '/login') {
          sessionStorage.removeItem('intendedPath');
          history.push(intendedPath);
        } else {
          history.push(urls.getTransactions());
        }
      });
    } catch (error) {
      console.error('Login error:', error);
      message.error('Login failed. Please check your credentials and try again.');
    } finally {
      setLoading(false);
    }
  };

  const onSignupFinish = async (values: SignupFormData) => {
    setSignupLoading(true);
    try {
      await register({
        email: values.email,
        first_name: values.first_name,
        last_name: values.last_name,
        company_name: values.company_name,
        password: values.password,
      });
      message.success('Registration successful! Please check your email to verify your account.');
      setShowSignup(false);
      signupForm.resetFields();
    } catch (error) {
      console.error('Signup error:', error);
      message.error('Registration failed. Please try again.');
    } finally {
      setSignupLoading(false);
    }
  };

  return (
    <div className={s.root}>
      <div className={s.block} style={{ width: '50%', height: '100vh' }}>
        <Slider />
      </div>
      <div
        className={s.block}
        style={{ padding: '0 70px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <div style={{ width: '452px' }}>
          {showForgotPassword ? (
            <ForgotPasswordForm onBack={() => setShowForgotPassword(false)} />
          ) : showSignup ? (
            <SignupForm
              form={signupForm}
              loading={signupLoading}
              onFinish={onSignupFinish}
              onLoginClick={() => setShowSignup(false)}
            />
          ) : (
            <LoginForm
              form={form}
              loading={loading}
              onFinish={onFinish}
              onSignupClick={() => setShowSignup(true)}
              onForgotPasswordClick={() => setShowForgotPassword(true)}
            />
          )}
        </div>
      </div>
    </div>
  );
}
